import React from 'react'
import './ResultsModal.css'
import ProgressBar from './ProgressBar/ProgressBar';

export default function ResultsModal(props) {
    let totalVotes = props.votes.jpc + props.votes.afp
    let jpcPercentage = (props.votes.jpc / totalVotes) * 100

    return (
        <div className="My-Modal-wrapper"
            style={{
                display: props.show ? 'block' : 'none',
                opacity: props.show ? '1' : '0'
            }}
        >
            <div className="My-Modal">
                <div className="My-Modal-header">
                    <h3>The Election Results</h3>
                    <span className="close-modal-btn" onClick={props.close}>×</span>
                </div>
                <div className="My-Modal-body">
                    <ProgressBar percentage={jpcPercentage} color="#5fd387" />
                    <p><i className="fas fa-stop" style={ {color:"#5fd387"} }></i> Jollof Peoples Congress - { props.votes.jpc }</p>
                    <p><i className="fas fa-stop" style={ {color:"#333333"} }></i> Asun For Progress - { props.votes.afp }</p>
                </div>
                <div className="My-Modal-footer text-center">
                    <button className="btn-cancel" onClick={props.close}>CLOSE</button>
                </div>
            </div>
        </div>
    )
}
